module.exports = __webpack_public_path__ + "static/img/p6.66060c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/p6.jpg
// module id = TM9i
// module chunks = 0